import type { DialogueTree } from './types';
import { BROKER_TREE } from './broker';
import { WIFE_TREE } from './wife';
import { MOM_TREE } from './mom';
import { DAD_TREE } from './dad';
import { SISTER_TREE } from './sister';
import { LAWYER_TREE } from './lawyer';
import { BEST_FRIEND_TREE } from './bestFriend';
import { SAUDI_PRINCE_TREE } from './saudiPrince';
import { SENATOR_TREE } from './senator';
import { REPORTER_TREE } from './reporter';

const REGISTRY: Record<string, DialogueTree> = {
  broker: BROKER_TREE,
  wife: WIFE_TREE,
  mom: MOM_TREE,
  dad: DAD_TREE,
  sister: SISTER_TREE,
  lawyer: LAWYER_TREE,
  best_friend: BEST_FRIEND_TREE,
  'saudi-prince': SAUDI_PRINCE_TREE,
  senator: SENATOR_TREE,
  reporter: REPORTER_TREE,
};

export function getDialogueTree(contactId: string): DialogueTree | undefined {
  return REGISTRY[contactId];
}

export function listDialogueContacts(): string[] {
  return Object.keys(REGISTRY);
}

export type { DialogueTree, DialogueChoice, DialogueResponse, ChoiceEffect } from './types';
